module.exports = __webpack_public_path__ + "media/grandville_loop_480.4997b846.mp4";